
import type { TransactionApi, TransactionLineItemApi } from "@/types/api/transactions";
import type { Transaction, TransactionLineItem, TransactionType, TransactionStatus } from "@/types/transaction";

function mapTransactionTypeApiToUi(apiType: string): TransactionType {
  const typeMap: Record<string, TransactionType> = {
    "invoice": "invoice",
    "credit_note": "credit_note",
    "receipt": "receipt",
    "debit_adjustment": "debit_adjustment",
    "credit_adjustment": "credit_adjustment",
  };
  return typeMap[apiType.toLowerCase()] ?? "invoice";
}

function mapTransactionStatusApiToUi(apiStatus: string): TransactionStatus {
  const statusMap: Record<string, TransactionStatus> = {
    "pending": "pending",
    "completed": "completed",
    "cancelled": "cancelled",
    "void": "void",
    "draft": "draft",
    "overdue": "overdue",
    "partially_paid": "partially_paid",
  };
  return statusMap[apiStatus.toLowerCase()] ?? "pending";
}

function mapLineItemApiToUi(apiLineItem: TransactionLineItemApi): TransactionLineItem {
  return {
    id: apiLineItem.id,
    lineNumber: apiLineItem.lineNumber,
    description: apiLineItem.description,
    quantity: apiLineItem.quantity,
    unitPrice: apiLineItem.unitPrice,
    subtotal: apiLineItem.subtotal,
    taxAmount: apiLineItem.taxAmount,
    discountAmount: apiLineItem.discountAmount,
    total: apiLineItem.total,
  };
}

export function mapTransactionApiToUi(apiTransaction: TransactionApi): Transaction {
  return {
    id: apiTransaction.id,
    referenceNumber: apiTransaction.referenceNumber,
    transactionDate: apiTransaction.transactionDate,
    customerId: apiTransaction.customerId,
    customerName: apiTransaction.customerName,
    transactionType: mapTransactionTypeApiToUi(apiTransaction.transactionType),
    amount: apiTransaction.amount,
    currency: apiTransaction.currency,
    status: mapTransactionStatusApiToUi(apiTransaction.status),
    description: apiTransaction.description ?? "",
    notes: apiTransaction.notes,
    createdBy: "",
    createdAt: apiTransaction.createdAt,
    modifiedAt: apiTransaction.modifiedAt,
    dueDate: apiTransaction.dueDate,
    invoiceNumber: apiTransaction.invoiceNumber,
    paymentMethod: apiTransaction.paymentMethod,
    reasonCode: apiTransaction.reasonCode,
    documentUrl: apiTransaction.documentUrl,
    outstandingAmount: apiTransaction.outstandingAmount,
    onDispute: apiTransaction.onDispute,
    lineItems: apiTransaction.lineItems?.map(mapLineItemApiToUi),
  };
}
